import type { FormFieldDto } from './dtos';

export function fieldWeight(field: Pick<FormFieldDto, 'weight'>): number {
    return typeof field.weight === 'number' && Number.isInteger(field.weight)
        && field.weight > 0 && field.weight <= 2147483647 ? field.weight : 1;
}
